<template>
<div>
  <div class="page dark intro">
    <div class="inner">

      
      <div class="offers">
        <div class="offer">
          <div class="cost">Recording</div>
          <div class="days">Recording</div>
          <div class="item">£25 / hour</div>
          <div class="item">£160 / 7 hour session</div>
        </div>

        <div class="offer">
          <div class="cost">Mixing
          </div>
          <div class="days">Mixing &amp; Mastering <em>(Unattended)</em></div>
          <div class="item">£20 / hour</div>
        </div>

        <div class="offer" style="text-align:left">
          <strong>Out of hours rates:</strong> £30 per hour <br />
          <strong>Mixdown / Master CD:</strong> £5 <br />
          <!-- (Now includes DVD of digital song files) -->

          <strong>DVD Project Backup:</strong> £5  <br />
          <!-- (Cubase 6.5 project files and audio stems) -->
          <strong>Postage:</strong> £5 / item

          
           <!-- Each hour outside of the normal working hours of 10am - 9pm will be charged at £25. -->
        </div>
        <div style="text-align:center; padding: 1em;" >
          <p>Minimum session: 3 Hours. <br />
        Working hours: 10am - 9pm</p>
        </div>
        
      </div>
      <div style="text-align:center"><strong>Please Note: </strong>Due to Covid-19 restrictions it is not currently possible to attend mixing and mastering sessions.</div>
  </div>
  </div>
  <div class="cards">
    <div class="big">
        <img src="../assets/cards.png" /> 
    </div>
    <div class="small">
      <img src="../assets/cards2.jpg" /> 
    </div>
  </div>
  <div class="page light text">
      <div class="inner">
        
        <h1>Rates</h1>
        <p>These are our only charges. It's easy and simple and everyone pays the same. This way you can concentrate on your project without worrying about building up unexpected fees.</p>

        <p>The rates above are for use of all the recording facilities and a qualified engineer or producer. They do not include fees or expenses charged by third parties such as session musicians or rental or purchase of additional equipment.  Fees are payable by debit / credit card, cash, cheque and bank transfer.</p>



        <p>Please be aware that we are only able to provide Cubase Projects on DVDs. Audio stems are 24Bit / 48kHz or 96kHz ".wav" files.</p>

        <p>DRUGS POLICY: Copse Corner operates a zero tolerance policy on drugs. If you are suspected of or found to be in possession of any class of illegal drugs on the premises, you will be asked to leave and reported to the police. No refund will be given for any time you have already spent at the studio.</p>
        <p>Please read our terms and conditions before booking a session.</p>

      </div>


    </div>


  </div>
  
</template>

<script>
export default {
  name: 'RatesIntro'
}
</script>

<style scoped lang="scss">
.strike{
  color:rgb(77, 43, 43);
  text-decoration: line-through;
}
.cards{
  text-align: center;
  width:100%;
  background-color:white;
  img{
    max-width:100%;
  }
}
.intro{

  display: flex;
  align-items: center;
  justify-content: center;
  padding-top:80px;
  min-height: 0;
  .inner{
    max-width: 1200px;
    
    padding:0 5%;

  }
}
.text{
  min-height:0;
  .inner{
    max-width:1200px;
    padding: 0 5%;
    margin: 0 auto;
  }
}
.offers{
  display:flex;
  justify-content: center;
  padding:100px 0;
  
  // align-content: center;
}
.offer{
  background: rgba(176, 176, 176, 0.667);
  border: 2px solid rgba(255,255,255,0.2);
  border-radius:10px;
  color: black;
  margin:1em;
  padding:1.5em;
  text-align: center;
  font-size: large;
}
.cost{
  font-size: xx-large;
  display:none;
}
.days{
  font-size:large;
  font-weight: bold;
}
.cards{
  .big{
    display: block;
  }
  .small{
    display: none;
  }
}
@media only screen and (max-width: 800px) {
  .offers{
    display: block;
  }
  .cards{
    .small{
      display: block;
    }
    .big{
      display: none;
    }
  }
}
</style>
